import {Injectable} from '@angular/core';
import {PageLayoutHandler} from '@spartacus/storefront';
import {combineLatest, Observable} from 'rxjs';
import {map, timeoutWith} from 'rxjs/operators';
import {DcpActiveCartService} from '../services/dcp-active-cart.service';

const UNSTABLE_SPARTACUS_TIMEOUT: number = 2000;

@Injectable({
  providedIn: 'root',
})
export class CartLayoutHandlerService implements PageLayoutHandler {
  constructor(protected activeCartService: DcpActiveCartService) {}

  private getCombinedObservable(slots$: Observable<string[]>): Observable<any> {
    return combineLatest([
      slots$,
      this.activeCartService
        .requireLoadedCart()
        .pipe(
          timeoutWith(
            UNSTABLE_SPARTACUS_TIMEOUT,
            this.activeCartService.requireLoadedCart()
          )
        ),
      this.activeCartService.getActiveCart(),
      this.activeCartService.getLoading(),
    ]);
  }

  handle(
    slots$: Observable<string[]>,
    pageTemplate?: string,
    section?: string
  ) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return this.getCombinedObservable(slots$).pipe(
        map(([slots, , cart]) => {
          const exclude: any = (arr, args) =>
            arr.filter((item) => args.every((arg) => arg !== item));

          return cart.totalItems === 0
            ? exclude(slots, [
                'TopContent',
                'CenterRightContentSlot',
                'LoadingContent',
              ])
            : cart.totalItems
            ? exclude(slots, ['EmptyCartMiddleContent', 'LoadingContent'])
            : exclude(slots, [
                'TopContent',
                'CenterRightContentSlot',
                'EmptyCartMiddleContent',
              ]);
        })
      );
    }
    return slots$;
  }
}
